import { Component, inject } from '@angular/core';
import { TranslatePipe, TranslateService } from '@codeandweb/ngx-translate';
import { ButtonDirective } from '@progress/kendo-angular-buttons';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { CardActionsComponent, CardBodyComponent, CardComponent, CardHeaderComponent, CardTitleDirective } from '@progress/kendo-angular-layout';
import { AppIdleDetectorService } from '@services/perform/idle-detector/app-Idle-detector.service';

const kendoComponents = [CardComponent, CardHeaderComponent, CardBodyComponent, CardActionsComponent, CardTitleDirective, ButtonDirective];

@Component({
    imports: [...kendoComponents, TranslatePipe],
    templateUrl: './idle-permission.dialog.html',
    styleUrl: './idle-permission.dialog.scss',
    
})
export class IdlePermissionDialog {

  private readonly idleDetectSvc : AppIdleDetectorService = inject(AppIdleDetectorService)
  

    public permissionGranted = false;
    constructor(public dialog: DialogRef) {}


    async onAllowClick() {
      const granted  = await this.idleDetectSvc.requestPermission();
      this.permissionGranted = granted
      this.dialog.close(this.permissionGranted);
    }
    
    onCloseClick() {
      this.permissionGranted = false;
      this.dialog.close(this.permissionGranted);
    }
    
}


